// extracted by mini-css-extract-plugin
module.exports = {"vWhite1":"#f2f2fa","app":"App_app__3BgQX","loader":"App_loader__1ZFtK"};